export const UserFields = [
  {
    label: "First Name",
    id: "firstName",
    placeHolder: "Enter first name",
    width: "",
    type: "text",
    required: true,
    validateInForm: true,
    toolTipId: "firstName",
    toolTipText: "First Name of the user.",
  },
  {
    label: "Last Name",
    id: "lastName",
    placeHolder: "Enter last name",
    width: "",
    type: "text",
    required: true,
    validateInForm: true,
    toolTipText: "Last Name of the user.",
  },
  {
    label: "Email",
    id: "email",
    placeHolder: "Enter email",
    width: "",
    type: "text",
    required: true,
    validateInForm: true,
    toolTipText: "Email of the user, which is not registered in VMS.",
  },
  {
    label: "Locale",
    id: "locale",
    width: "",
    type: "select",
    disabled: true,
    //value: "english",
    dynamicOptionLable: "locale",
    required: false,
    validateInForm: true,
  },
  {
    label: "Enterprise Name/Vendor Corp Name",
    id: "enterpriseName",
    placeHolder: "Enterprise Name",
    width: "",
    type: "text",
    disabled: true,
  },
  {
    label: "Roles",
    id: "vmsFOMRoles",
    width: "",
    type: "select",
    disabled: false,
    dynamicOptionLable: "vmsFOMRoles",
    required: true,
    validateInForm: true,
    toolTipText: "Select preferred VMS Role for the user.",
  },
  {
    label: "Phone",
    id: "phone",
    placeHolder: "(123) 456-7890",
    width: "",
    type: "text",
    validateInForm: true,
    disabled: true,
  },
];

export const UserAddressFields = [
  {
    label: "Address",
    id: "address",
    placeHolder: "Enter address",
    width: "",
    type: "addressAutocomplete",
    pageFrom: "AddUser",
    disabled: true,
    required: false,
    class: "mb-4 form-grid-items",
  },
];

export const FomFields = [
  {
    label: "Available Roles",
    id: "availableRoles",
    placeHolder: "Select...",
    width: "",
    type: "select",
    value: "basic",
    dynamicOptionLable: "availableFOMRoles",
    class: "form-group col-md-4",
    required: true,
    validateInForm: true,
    toolTipText: "Select preferred VSP Available Roles for the user.",
  },
];
